type GetRosContactDetailRedirectUrlParams = {
	baseUrl?: string;
	ico?: number;
	agendaCode?: string;
};

export const getRosContactDetailRedirectUrl = ({
	baseUrl,
	ico,
	agendaCode,
}: GetRosContactDetailRedirectUrlParams) => {
	if (ico === undefined) return baseUrl;
	return baseUrl
		? `${baseUrl}/${ico}${agendaCode ? '/' + agendaCode : ''}`
		: undefined;
};
